"use client";

import { Typography } from "@kyan/ui";

import { useIsOptionHedged } from "#/store/options/tradePanel/isOptionHedged";
import { useOption } from "#/store/options/tradePanel/option";
import { useOptionMarketOrderType } from "#/store/options/tradePanel/optionMarketOrderType";
import { MarketOrder } from "#/types/orders";

export const HedgeButton: React.FC = () => {
  const { option } = useOption();
  const { setIsOptionHedged } = useIsOptionHedged();
  const { setOptionMarketOrderType } = useOptionMarketOrderType();

  const underlying = option?.underlying;

  const handleAddHedge = () => {
    setIsOptionHedged(true);
    setOptionMarketOrderType(MarketOrder.FOK);
  };

  return (
    <button
      className="hover:text-textPrimary group bg-textSecondary/15 mt-2 flex h-7.5 w-full cursor-pointer items-center justify-between rounded-md px-2 transition-colors"
      onClick={handleAddHedge}
    >
      <Typography xs>Want to hedge this option?</Typography>
      <Typography
        xs
        grotesk
        className="relative bg-gradient-to-r from-[#3F4DFF] to-[#9B57FF] bg-clip-text text-transparent transition-all group-hover:after:absolute group-hover:after:bottom-0 group-hover:after:left-0 group-hover:after:h-px group-hover:after:w-full group-hover:after:bg-gradient-to-r group-hover:after:from-[#3F4DFF] group-hover:after:to-[#9B57FF] group-hover:after:content-['']"
      >
        + Add {underlying} Perp
      </Typography>
    </button>
  );
};
